import ArticleLayout from '@/components/feature/ArticleLayout';

export default function BeginnerGuideArticle() {
  return (
    <>
      <title>Superbuy Spreadsheet Beginner Guide: How to Start Shopping Smarter in 2026</title>
      <meta name="description" content="Complete Superbuy Spreadsheet beginner guide — learn how to navigate 14 categories, read product listings, compare prices, and place your first successful order. Perfect for first-time international shoppers." />
      <meta name="keywords" content="superbuy spreadsheet beginner guide, how to use superbuy spreadsheet, superbuy sheet for beginners, superbuy spreadsheet tutorial, superbuy spreadsheet first time, superbuy spreadsheet explained" />
      <link rel="canonical" href={`${import.meta.env.VITE_SITE_URL || 'https://superbuyspread.makeup'}/superbuy-spreadsheet-beginner-guide`} />
      <ArticleLayout slug="superbuy-spreadsheet-beginner-guide" />
    </>
  );
}